export default __webpack_public_path__ + "static/media/109-money.a036c8bf.svg";